package dev.lingvo.site.components.studio.compose

import dev.lingvo.shared.screenshots.render.RenderReport
import dev.lingvo.site.i18n.tr
import dev.lingvo.site.i18n.t

/** A clipped or replaced primary layer cannot silently become a caption-free schema-3 upload. */
internal fun verifiedComposeCaption(job: ComposeJob, report: RenderReport): String? {
    if (job.schemaVersion < 3) return report.slotCaption
    val primary = report.texts.filter { it.primaryCaption }
    check(primary.size == if (job.primaryCaptionId == null) 0 else 1) {
        tr("studio.compose.compose_caption_provenance.the_caption_layer_changed_since_planning", "The caption layer changed since planning. Refresh the design and retry.")
    }
    val caption = primary.singleOrNull()
    check(caption?.layerId == job.primaryCaptionId) {
        tr("studio.compose.compose_caption_provenance.the_caption_layer_changed_since_planning", "The caption layer changed since planning. Refresh the design and retry.")
    }
    return caption?.sourceText
}
